<template>
    <div>
        <van-nav-bar
                title="会员管理"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
        />
        <van-cell-group>
            <van-cell icon="search" is-link to="/mobile/member/search">
                <template slot="title">
                    <span class="van-cell-text">客户查询</span>
                </template>
            </van-cell>
            <van-cell title="会员卡" icon="idcard" is-link to="/mobile/member/card"/>

        </van-cell-group>
    </div>
</template>

<script>
    import {CellGroup,Cell,Icon,NavBar} from 'vant'
    export default {
        name: "index",
        components:{
            [CellGroup.name]:CellGroup,
            [Cell.name]:Cell,
            [Icon.name]:Icon,
            [NavBar.name]:NavBar
        },
        methods:{
            onClickLeft(){
                this.$router.back()
            }
        }
    }
</script>

<style scoped>

</style>
